import { createI18n } from 'vue-i18n'

import { localize, setLocale } from '@vee-validate/i18n'
import elementCsLocale from 'element-plus/es/locale/lang/cs'
import elementDeLocale from 'element-plus/es/locale/lang/de'
// element-ui built-in lang
import elementEnLocale from 'element-plus/es/locale/lang/en'
import elementKoLocale from 'element-plus/es/locale/lang/ko'
import elementPtLocale from 'element-plus/es/locale/lang/pt'
import elementSkLocale from 'element-plus/es/locale/lang/sk'

import { theme } from '@/theming'
import { getLanguage } from '@/utils/cookies'
import { merge } from '@/utils/merge'
const theme1 = theme() || 'fu'

import { AllowedLang, eAllowedLangs } from '@/types/shared'

import csDefaultLocale from './cs'
import csCSLocale from './cs/cs'
import deCSLocale from './cs/de'
import enCSLocale from './cs/en'
import koCSLocale from './cs/ko'
import ptCSLocale from './cs/pt'
// CS => CitySys specific lang
import skCSLocale from './cs/sk'
import deDefaultLocale from './de'
import enDefaultLocale from './en'
import csFULocale from './fu/cs'
import deFULocale from './fu/de'
import enFULocale from './fu/en'
import koFULocale from './fu/ko'
import ptFULocale from './fu/pt'
// User defined lang
// Fu => FacilityUp specific lang
import skFULocale from './fu/sk'
import csIMLocale from './im/cs'
import deIMLocale from './im/de'
import enIMLocale from './im/en'
import koIMLocale from './im/ko'
import ptIMLocale from './im/pt'
// IM => IoMobility specific lang
import skIMLocale from './im/sk'
import koDefaultLocale from './ko'
import ptDefaultLocale from './pt'
import skDefaultLocale from './sk'
import csWSLocale from './ws/cs'
import deWSLocale from './ws/de'
import enWSLocale from './ws/en'
import koWSLocale from './ws/ko'
import ptWSLocale from './ws/pt'
// WS => WorkSys specific lang
import skWSLocale from './ws/sk'

let skLocale: Record<string, any> = skFULocale
let enLocale: Record<string, any> = enFULocale
let deLocale: Record<string, any> = deFULocale
let csLocale: Record<string, any> = csFULocale
let koLocale: Record<string, any> = koFULocale
let ptLocale: Record<string, any> = ptFULocale

// fu, cs, ws, im,
if (theme1 === 'cs') {
  skLocale = skCSLocale
  enLocale = enCSLocale
  deLocale = deCSLocale
  csLocale = csCSLocale
  koLocale = koCSLocale
  ptLocale = ptCSLocale
} else if (theme1 === 'ws') {
  skLocale = skWSLocale
  enLocale = enWSLocale
  deLocale = deWSLocale
  csLocale = csWSLocale
  koLocale = koWSLocale
  ptLocale = ptWSLocale
} else if (theme1 === 'im') {
  skLocale = skIMLocale
  enLocale = enIMLocale
  deLocale = deIMLocale
  csLocale = csIMLocale
  koLocale = koIMLocale
  ptLocale = ptIMLocale
}

const en = merge(enDefaultLocale, enLocale)
const sk = merge(skDefaultLocale, skLocale)
const de = merge(deDefaultLocale, deLocale)
const cs = merge(csDefaultLocale, csLocale)
const ko = merge(koDefaultLocale, koLocale)
const pt = merge(ptDefaultLocale, ptLocale)

const messages = {
  en: {
    ...en,
    ...elementEnLocale,
  },
  sk: {
    ...sk,
    ...elementSkLocale,
  },
  de: {
    ...de,
    ...elementDeLocale,
  },
  cs: {
    ...cs,
    ...elementCsLocale,
  },
  ko: {
    ...ko,
    ...elementKoLocale,
  },
  pt: {
    ...pt,
    ...elementPtLocale,
  },
}

export const getLocale = (): AllowedLang => {
  const cookieLanguage = getLanguage()
  if (cookieLanguage) {
    return cookieLanguage
  }

  const language = navigator.language.toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.includes(locale)) {
      return locale as AllowedLang
    }
  }
  // Default language is english
  return eAllowedLangs.EN
}

const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  messages,
})
console.log('i18nStart', i18n)

console.log('getLocale', getLocale())
localize(getLocale())
setLocale(getLocale())

let titleByTheme = 'FacilityUp platform'

if (theme() === 'cs') {
  titleByTheme = 'CitySys platform'
}
if (theme() === 'ws') {
  titleByTheme = 'WorkSys platform'
}

if (theme() === 'im') {
  titleByTheme = 'IoMobility'
}

export const title = titleByTheme

export default i18n
